var map = {
	"./fc_logo_v2.png": 1198,
	"./logo-caen.png": 2887,
	"./logo-charles-perrens.png": 2220,
	"./logo-chic.png": 5411,
	"./logo-codoc.svg": 2768,
	"./logo-foch.png": 9690,
	"./logo-ghu.png": 5978,
	"./logo-hospital.png": 2912,
	"./logo-igr.png": 1746,
	"./logo-imm.png": 2935,
	"./logo-mpl.svg": 4357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4336;